<template>
  <div class="sidebar-container">
    <div class="sidebar-logo-container">
      <router-link
        key="expand"
        class="sidebar-logo-link"
        to="/"
      >
        <img
          src="../../assets/images/logo.jpg"
          alt=""
          class="sidebar-logo"
        >
      </router-link>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :unique-opened="false"
        :collapse-transition="false"
        mode="vertical"
        router
        @select="handleSelect"
      >
        <el-menu-item index="/home">
          <i class="iconfont icon-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item
          v-if="havePermissions('/hgyj')"
          @click="getMessageH(95)"
          index="/hgyj"
        >
          <i class="iconfont icon-hgyj"></i>
          <!-- <span slot="title">{{ hgyg }}</span> -->
          <span slot="title">典型工艺</span>
        </el-menu-item>
        <el-menu-item
          v-if="havePermissions('/feature')"
          @click="getMessageF(136)"
          index="/feature"
        >
          <i class="el-icon-data-line"></i>
          <span slot="title">特征解析</span>
        </el-menu-item>
        <el-menu-item
          v-if="havePermissions('/dataStatistics')"
          index="/dataStatistics"
        >
          <i class="el-icon-s-data"></i>
          <span slot="title">数据统计</span>
        </el-menu-item>
        <el-menu-item
          v-if="havePermissions('/data')"
          index="/data"
        >
          <i class="iconfont icon-course"></i>
          <span slot="title">数据录入</span>
        </el-menu-item>
        <el-menu-item
          v-if="havePermissions('/specialService')"
          index="/specialService"
        >
          <i class="el-icon-guide"></i>
          <span slot="title">特别服务</span>
        </el-menu-item>
        
        <el-menu-item
          v-if="havePermissions('/aboutUs')"
          @click="getMessageA(96)"
          index="/aboutUs"
        >
          <i class="iconfont icon-member-o"></i>
          <span slot="title">关于我们</span>
          <!-- <span slot="title">{{ about }}</span> -->
        </el-menu-item>
        <el-menu-item
          v-if="havePermissions('/system')"
          index="/system"
        >
          <i class="el-icon-s-cooperation"></i>
          <span slot="title">系统管理</span>
        </el-menu-item>
      </el-menu>
    </el-scrollbar>

  </div>
</template>

<script>
import { getPage } from '@/api/page'
import { mapMutations, mapGetters } from 'vuex'
export default {
  computed: {
    activeMenu() {
      console.log(this.$route.path.split('/')[1])
      return '/' + this.$route.path.split('/')[1]
    },
    ...mapGetters(['permissions']),
  },
  data() {
    return {
      hgyg: '',
      about: '',
      mapList: {},
      activeId: '',
      name: '',
    }
  },
  mounted() {
    getPage({
      id: null,
      parentId: 0,
      page: 1,
      size: 50,
    }).then((res) => {
      this.mapList = res
      //   for (const key in this.mapList) {
      //     if (key == '化工冶金') {
      //       this.hgyg = this.mapList[key].pageName
      //     } else {
      //       this.about = this.mapList[key].pageName
      //     }
      //   }
    })
  },
  methods: {
    ...mapMutations(['setCurrentId', 'setPageList']),
    getMessageH(id) {
      const itemData = this.mapList.filter((item) => item.id === id)[0]
      this.activeId = itemData.id
      this.setCurrentId(this.activeId)
      this.setPageList(itemData.childrenList)
      this.$router.push({
        name: 'hfyj',
        params: {
          id: itemData.childrenList[0].id,
        },
      })
    },
    getMessageA(id) {
      const itemData = this.mapList.filter((item) => item.id === id)[0]
      this.activeId = itemData.id
      this.setCurrentId(this.activeId)
      this.setPageList(itemData.childrenList)
      this.$router.push({
        name: 'aboutUsDetail',
        params: {
          id: itemData.childrenList[0].id,
        },
      })
    },
    getMessageF(id) {
      const itemData = this.mapList.filter((item) => item.id === id)[0]
      this.activeId = itemData.id
      this.setCurrentId(this.activeId)
      this.setPageList(itemData.childrenList)
      if (itemData.childrenList[0]) {
        const itemData2 = itemData.childrenList[0]
        if (itemData2.childrenList[0]) {
          this.$router.push({
            name: 'feature',
            params: {
              id: itemData2.childrenList[0].id,
            },
          })
        } else {
          this.$router.push({
            name: 'feature',
            params: {
              id: itemData.childrenList[0].id,
            },
          })
        }
      }
    },
    handleSelect(index) {
      console.log(index)
    },
    havePermissions(route) {
      return this.permissions.some((item) => item.route === route)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/sidebar.scss';
</style>